import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetMailingStatisticsScrollerOpenGameByUser } from '../../../../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerOpenGameByUser';
import ScrollerOpenGame from '../Scroller';
import { setGetMailingStatisticsScrollerUsersDepositsByUser } from '../../../../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerUsersDepositsByUser';

const UserItem = ({
    login,
    index,
    mailing_id
}) => {
    const dispatch = useDispatch();
    const [isShowDetail, setIsShowDetail] = React.useState(false);

    const handleShowDetail = () => {
        setIsShowDetail((value) => !value);

        if (!isShowDetail) {
            dispatch(setGetMailingStatisticsScrollerUsersDepositsByUser({
                mailing_id, 
                login, 
                page: 1,
                pageSize: 25
            }))
        }
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '100%' }}>
            <div style={{ background: `rgba(24, 32, 58, ${index % 2 === 0 ? 1 : 0.7})`, padding: '10px 20px', borderRadius: 3, display: 'flex', alignItems: 'center', columnGap: 12, borderTop: '1px solid #141b33' }}>
                <span style={{
                    color: "#FFFFFF",
                    fontWeight: 700,
                }}>{login}</span>
                <span onClick={handleShowDetail} style={{
                    color: '#3787FF',
                    cursor: 'pointer',
                    borderBottom: '1px dashed #3787FF'
                }}>{isShowDetail ? "свернуть" : "детально"}</span>
            </div>
            {
                isShowDetail && (
                    <ScrollerOpenGame login={login} mailing_id={mailing_id} />
                )
            }
        </div>
    )
}

export default UserItem;